import React from "react";
import { FileField } from "./FileField";

// "file/link" answer type — accepts uploaded files OR a pasted URL.
// Storage shape: { files: [], link: "" }.
//
// Layout: stacked by default; pass question.config.inline = true (or
// "side_by_side") to render the link input + upload button on one row,
// matching the legacy "Do you have references? upload them here" layout.
export const FileLinkField = ({ question, value, onChange, lang }) => {
  const v = value && typeof value === "object" ? value : { files: [], link: "" };
  const inline = !!(question.config && (question.config.inline || question.config.side_by_side));
  const placeholder =
    lang === "ar" ? question.placeholder_arabic || "أو ألصق رابطًا" : question.placeholder || "Or paste a link";

  if (inline) {
    return (
      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <input
          type="url"
          className="dq-input"
          style={{ flex: 1, minWidth: 200 }}
          placeholder={placeholder}
          value={v.link || ""}
          onChange={(e) => onChange({ ...v, link: e.target.value })}
        />
        <span style={{ fontSize: 13, color: "#888" }}>
          {lang === "ar" ? "أو" : "OR"}
        </span>
        <FileField
          question={{ ...question, allow_multiple: true }}
          value={v.files}
          onChange={(files) => onChange({ ...v, files })}
        />
      </div>
    );
  }

  return (
    <div>
      <FileField
        question={{ ...question, allow_multiple: true }}
        value={v.files}
        onChange={(files) => onChange({ ...v, files })}
      />
      <input
        type="url"
        className="dq-input"
        style={{ marginTop: 12 }}
        placeholder={placeholder}
        value={v.link || ""}
        onChange={(e) => onChange({ ...v, link: e.target.value })}
      />
    </div>
  );
};
